import type { Procedure } from "@interfaces";
import { createCachedSearchService } from "./createCachedSearchService";

export const getMedicalProceduresSuggestions = createCachedSearchService<Procedure>(
  "mekidoc-medical-procedures",
  "medical procedures suggestions",
);
